import { useStoreBoot } from '@/api/useStoreBoot';
import { BootData } from '@/lib/types';

import { useTranslations } from 'next-intl';

import { AuthHelpLink } from './AuthHelpLink';

export const FindPlayerId = (): React.ReactElement | null => {
  const t = useTranslations();
  const { getBoot } = useStoreBoot();
  const bootData = getBoot.data as BootData;

  const { userTokenOn, userTokenUrl, userTokenText } =
    bootData?.integration?.playersAuthentication ?? {};

  return (
    <AuthHelpLink
      on={userTokenOn}
      text={userTokenText}
      url={userTokenUrl}
      testId="PortalLoginModal-FindPlayerId"
      ariaLabel={t('portal.login.findPlayerId')}
    />
  );
};
